import type { OptionType } from "Shared/Components/Form/CustomFormComponent/Select";
import {
	type PartnerResponseDto,
	PartnerStatus,
} from "../../Infrastructure/Api/Api.ts";
import {
	formatPartnerName,
	type PartnerNameOrder,
} from "./formatPartnerName.ts";

export const transformAndSortPartners = (
	partners: PartnerResponseDto[] | undefined,
	orderRegionName?: string,
	nameOrder: PartnerNameOrder = "given-first",
): OptionType[] => {
	const transformedData =
		partners
			?.filter(
				(partner) =>
					partner.partner.status !== PartnerStatus.BLOCKED &&
					partner.partner.status !== PartnerStatus.DELETED,
			)
			.map((partner) => ({
				value: partner.partner.id,
				label: formatPartnerName(partner.partner, nameOrder),
				//TODO[JAKUB]: Please add translation here
				region: partner.region?.name ?? "Without region",
			})) ?? [];

	return transformedData.sort((a, b) => {
		if (a.region === orderRegionName) return -1;
		if (b.region === orderRegionName) return 1;
		return a.region.localeCompare(b.region);
	});
};
